<template>
  <span class="date-time-label">{{
    this.value | dateTimeFilter({ format, timeZone })
  }}</span>
</template>
<style lang="sass" scoped>
  @import src/styles/defaults/variables
  @import "src/styles/defaults/mobile-first"

  .date-time-label
    +media-min-sm()
    +media-min-md()
    +media-min-lg()
</style>

<script>
import { formats } from '@/constants/localizer';

export default {
  props: {
    value: String,
    format: {
      default: () => formats.DATETIME_SHORT_WITH_SECONDS,
      required: false,
      type: [Object, String],
    },
    timeZone: {
      required: false,
      type: String,
    },
  },
};
</script>
